export const CONTACT = {
  email: "solutions@raecloudllc.com",
  phone: "(945) 289-6585",
  phoneHref: "tel:+19452896585",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/1313534/pexels-photo-1313534.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  itStrategy: "https://images.unsplash.com/photo-1667984390538-3dea7a3fe33d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGNsb3VkJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3ODMwNDIwMjV8MA&ixlib=rb-4.1.0&q=85",
  techWriting: "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHx0ZWNobmljYWwlMjB3cml0aW5nJTIwY29kZSUyMHNjcmVlbnxlbnwwfHx8fDE3ODMwNDIwMjV8MA&ixlib=rb-4.1.0&q=85",
  about: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzgzMDQyMDI1fDA&ixlib=rb-4.1.0&q=85",
};
